<script>
    import { createEventDispatcher } from 'svelte';
    import { link } from "svelte-routing";
    import { deleteGroup } from "../../../services/groupService";
    import { exportSubscribersToXLSX } from "../../../services/subscribersService";
    import { downloadFile } from "../../../utils/downloadFile";
    import { format } from "date-fns";
    import DeleteButton from "../DeleteButton.svelte";
    import { groupTypeByAncestorCount } from "../../../utils/subscribers";
    import { isAdmin, isGroupManager, loggedUser } from "../../../stores/settingsStore";
    import toast from "svelte-french-toast";
    import ButtonPromise from "../../Button/ButtonPromise.svelte";
    import { selectedActiveYear } from "../../../stores/selectedActiveYear"

    const dispatch = createEventDispatcher()
    export let group;
    let element="il gruppo";
    let exportToXLSXPromise = null;

    async function handleExportToXLSX() {
        exportToXLSXPromise = (async () => {
            try {
                const data = await exportSubscribersToXLSX({ groupId: group.id, referenceYear: $selectedActiveYear });
                const fileName = `iscritti_${group.name}_${format(new Date(), "dd_MM_yyyy")}.xlsx`;
                downloadFile(document, data.data, fileName);
                toast.success("Esportazione completata");
            } catch (err) {
                if (err?.response?.status === 500) {
                    toast.error(`Impossibile esportare il gruppo, errore ${err.toString()}`);
                }
            } finally {
                exportToXLSXPromise = null;
            }
        })();
    }

    async function handleDeleteGroup(groupId) {
        deleteGroup(groupId).then(() => {
            updateTable();
            toast.success("Gruppo eliminato");
        }).catch((err) => {
            console.error(err)
            toast.error(`Impossibile eliminare il gruppo, errore ${err.toString()}`);
        })
    }

    function updateTable() {
        dispatch('delete', { state: "group deleted" });
    }
</script>


<tr class="h-14 border-b">
    <td>{group.name}</td>
    <td>{groupTypeByAncestorCount.find(g => g.match(group.ancestorsCount)).value}</td>
    <td>{!isNaN(group.membershipsCount) ? group.membershipsCount : ""}</td>
    <td>{group.minSubscribers !== null ? group.minSubscribers : ""}</td>
    <td class="flex h-14 justify-center items-center">
        {#if (group.membershipsCount > group.minSubscribers) && !!group.minSubscribers && !isNaN(group.minSubscribers) }
            <div class="w-5 h-5 bg-yellow-400 animate-pulse opacity-75 rounded-full"></div>
        {/if}
    </td>
    <td class="text-right">
        {#if ($isAdmin || $isGroupManager) && (groupTypeByAncestorCount.find(g => g.match(group.ancestorsCount)).value === 'Circolo')}
            <ButtonPromise
                handleClick="{() => handleExportToXLSX()}"
                bind:promise={exportToXLSXPromise}
                icon="fa-file-export"
                buttonClass="mr-3"
                size="16"
                moonColors={["#0ea5e9", "#0ea5e9"]}
            />
        {/if}

        {#if !$isGroupManager || $loggedUser.groupId !== group.id}
            <a
                use:link
                href="/admin/groups/edit?id={group.id}"
                class="mr-3"
            >
                <span class="w-10 h-10 text-sm border inline-flex items-center justify-center rounded-full cursor-pointer">
                    <i class="fa fa-edit"></i>
                </span>
            </a>
        {/if}

        {#if $isAdmin}
            <DeleteButton
                buttonText="Elimina"
                message="Vuoi eliminare il gruppo?"
                buttonClass="w-44"
                on:delete={() => handleDeleteGroup(group.id)}
            />
        {/if}
    </td>
</tr>

